var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('page-alerts'),_c('page-end-user-license-agreement'),(!_vm.$currentUser.loggedIn())?_c('cta-modal'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }